import { render, staticRenderFns } from "./AssetEditorVideoTranscriptControls.vue?vue&type=template&id=aadbcc18&scoped=true&"
import script from "./AssetEditorVideoTranscriptControls.vue?vue&type=script&lang=js&"
export * from "./AssetEditorVideoTranscriptControls.vue?vue&type=script&lang=js&"
import style0 from "./AssetEditorVideoTranscriptControls.vue?vue&type=style&index=0&id=aadbcc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadbcc18",
  null
  
)

export default component.exports